<a class="twitter-timeline"
   data-theme="dark"
   data-chrome="transparent nofooter noheader"
   data-tweet-limit="1"
   data-width="430"
   data-height="300"
   href="{{href}}">{{title}}</a>
<script src="https://platform.twitter.com/widgets.js" charset="utf-8"></script>
